<template>
	<section
		v-if="toShow"
	>
		<a id="gift"></a>
		<div class="section-content flex">
			<div>
				<h2 class="show-mobile">
					&#127873; Quomi Day &#127873;
				</h2>

				<scratch-card
					class="scratch"
					:percentage.sync="percentage" 
					:alreadyAdded="alreadyAdded"
					:image='alreadyAdded ? freeExtra.images.small : menuStore.freeExtra.image'
					:title='alreadyAdded ? freeExtra.title : menuStore.freeExtra.title'
				/>
			</div>

			<div class="left-content">
				<h2 class="show-desktop">
					&#127873; Quomi Day &#127873;
				</h2>
				
				<h3>
					<b>C'è un regalo per te!</b>
				</h3>

				<p>
					Dicembre è un mese speciale per Quomi, ogni lunedì una nuova sorpresa per te.<br>
					<b>Gratta il logo Quomi dorato</b> e scopri cosa ti abbiamo riservato questa settimana.
				</p>

				<CTA
					v-if="!alreadyAdded"
					:content="`Aggiungi all'ordine`"
					:color="`gold`"
					:disabled="!scratched"
					@click="addFreeExtra"
				/>

				<div
					v-if="alreadyAdded"
				>
					<i class="fas fa-check" />&nbsp;<b>Il tuo Regalo è stato aggiunto correttamente :)</b>
				</div>
			</div>

		</div>
	</section>
</template>

<script>
import ScratchCard from '../Parts/ScratchCard'
import { UserApi } from '../../api/UserApi'

import { menuStore } from '../../store/menuStore' 

import { scrollToElementId } from '../../assets/js/main'

export default {
	data () {
		return {
			menuStore: menuStore.state,

			percentage: null
		}
	},

	components: {
		ScratchCard
	},

	computed: {
		user () {
			return this.$root.user
		},

		alreadyAdded () {
			return this.user.order
				&& this.menuStore.freeExtra.ids
				&& !!this.user.order.extras.find(r => this.menuStore.freeExtra.ids.includes(r.id))
		},

		freeExtra () {
			return this.alreadyAdded && this.user.order.extras.find(r => this.menuStore.freeExtra.ids.includes(r.id))
		},

		scratched () {
			return this.percentage >= 50 && this.menuStore.freeExtra.id
		},

		toShow () {
			if (process.env.NODE_ENV === 'development') return true
			return this.user.subscription && this.menuStore.menu
				&& this.user.subscription.orders_processed >= (process.env.NODE_ENV === 'development' ? 0 : 2) 
	          	&& this.menuStore.freeExtra.config 
	            	.map(r => r.menuId) 
	            	.includes(this.menuStore.menu.id) 
		}
	},

	methods: {
		addFreeExtra () {
			menuStore.state.freeExtra.active = true
			this.$router.push({name: 'flow-subscribed'})
		}
	},

	mounted () {
		if (this.$route.params.slug === 'gift') {
			scrollToElementId('gift')
		}
	}
}

</script>

<style scoped>

.left-content {
	flex-basis: calc(100% - 330px)
}
.section-content {
	border-radius: 6px;
	border: 6px solid #E5C100;
	justify-content: space-between;
}

.fa-check {
	color: var(--quomi-primary);
}

.show-mobile {
	display: none;
}

.show-desktop {
	display: block;
}
@media (max-width: 570px) {
	.show-desktop {
		display: none;
	}

	.show-mobile {
		display: block;
	}

	.scratch {
		margin: 10px 0 10px 0;
	}
	.section-content {
		flex-direction: column;
	}
}
</style>
